import ProductItem from '../components/product/ProductItem';

export default function initProductItemEvents() {
  document.addEventListener('product-item:init', event => {
    const { productItem } = event.detail;
    new ProductItem(productItem);
  });
}
